import React, { useEffect } from 'react';
import AppRoutes from "./routes/Routes";
import { trackPageView } from './analytics/tracker';

const App = () => {
  useEffect(() => {
    trackPageView();
  }, []);

  return (
    <div>
      <AppRoutes />
    </div>
  );
};

export default App;
